import { useEffect, useRef, useState } from 'react';
import { ChevronDown, LogOut, Settings, UserRound } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ACTIONS, RESOURCES, ROLE_LABELS } from '../../config/accessControl';
import { useAuth } from '../../context/AuthContext';
import usePermissions from '../../hooks/usePermissions';
import { classNames } from '../../utils/classNames';

function UserMenu() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { can } = usePermissions();
  const initials = user.name.split(' ').slice(0, 2).map((part) => part[0]).join('');

  useEffect(() => {
    const close = (event) => !ref.current?.contains(event.target) && setOpen(false);
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      navigate('/login', { replace: true });
    }
  };

  return (
    <div ref={ref} className="relative">
      <button type="button" onClick={() => setOpen((value) => !value)} className="flex items-center gap-2 rounded-control p-1.5 text-left transition hover:bg-slate-100" aria-expanded={open}>
        <span className="grid size-8 place-items-center rounded-full bg-primary-100 text-xs font-bold text-primary-800">{initials}</span>
        <span className="hidden min-w-0 sm:block">
          <span className="block max-w-36 truncate text-sm font-semibold leading-4 text-content-primary">{user.name}</span>
          <span className="mt-0.5 block text-xs text-content-muted">{ROLE_LABELS[user.role]}</span>
        </span>
        <ChevronDown className={classNames('hidden size-4 text-content-muted transition sm:block', open && 'rotate-180')} />
      </button>
      {open && (
        <div className="absolute right-0 top-12 z-50 w-60 rounded-card border bg-white p-1.5 shadow-elevated">
          <div className="border-b px-3 py-2.5 sm:hidden">
            <p className="truncate text-sm font-semibold text-content-primary">{user.name}</p>
            <p className="mt-0.5 text-xs text-content-muted">{ROLE_LABELS[user.role]}</p>
          </div>
          <button className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm text-content-secondary hover:bg-slate-100">
            <UserRound className="size-4" /> Mi perfil
          </button>
          {can(RESOURCES.SETTINGS, ACTIONS.VIEW) && (
            <button onClick={() => navigate('/configuracion')} className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm text-content-secondary hover:bg-slate-100">
              <Settings className="size-4" /> Configuración
            </button>
          )}
          <div className="my-1 border-t" />
          <button onClick={handleLogout} className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-danger-600 hover:bg-danger-50">
            <LogOut className="size-4" /> Cerrar sesión
          </button>
        </div>
      )}
    </div>
  );
}

export default UserMenu;
